import React, { useContext, useEffect, useState } from "react";
import InputRegister from "../../../../blocks/ui/InputRegister";
import { IoMdAdd } from "react-icons/io";
import { FiEdit2 } from "react-icons/fi";
import { MdDeleteOutline } from "react-icons/md";
import { DContext } from "../../../../../context/Datacontext";
import { CandidateProjectsvalidate } from '../../../../../utils/validator'

import { createProjects } from "../../../../services/Candidate/Profile/HighLights/projects/createProjects";
import { updateProjects } from "../../../../services/Candidate/Profile/HighLights/projects/updateProjects";
import { deleteProjects } from "../../../../services/Candidate/Profile/HighLights/projects/deleteProjects";

const makeEmptySkill = (overrides = {}) => ({
    projectName: overrides.projectName ?? "",
    clientName: overrides.clientName ?? "",
    periodFrom: overrides.periodFrom ?? ["", "", ""],
    periodTo: overrides.periodTo ?? ["", "", ""],
    location: overrides.location ?? "",
    description: overrides.description ?? "",
    isProcessing: overrides.isProcessing ?? false,
    role: overrides.role ?? ""
});

export const Projects = ({ candidate }) => {
    const { BeURL, formatPeriod, showAlert } = useContext(DContext)
    const [projects, setProjects] = useState([]);
    const [topInput, setTopInput] = useState(makeEmptySkill());
    const [editingCardId, setEditingCardId] = useState(null);
    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});

    const mandatory = {
        projectName: true,
        role: true,
    }

    useEffect(() => {
        if (Array.isArray(candidate?.projects)) {
            setProjects(candidate?.projects);
        }
    }, [candidate?.projects]);

    const handleTopFieldChange = (field, value) => {
        setTopInput(prev => ({ ...prev, [field]: value }));
        CandidateProjectsvalidate({ ...topInput, [field]: value }, setErrors ,mandatory)
    };

    const handleTopAdd = () => {
        if (!CandidateProjectsvalidate(topInput ,setErrors , mandatory)) return        
        createProjects({ BeURL, projects: [topInput], showAlert, handleTopClear, setProjects,candidateId: candidate._id })
    };

    const handleTopUpdate = (id) => {
        if (!CandidateProjectsvalidate(topInput, setErrors, mandatory)) return
        setProjects(prev =>
            prev.map(c => (c.id === editingCardId ? { ...c, ...topInput, id: c.id } : c))
        );
        updateProjects({ BeURL, id, projects: [topInput], showAlert, handleTopClear, setProjects,candidateId: candidate._id })
    };

    const handleTopClear = () => {
        setTopInput(makeEmptySkill());
        setErrors({});
        setTouched({});
        setEditingCardId(null);
    };

    const handleCardDelete = (id) => {
        if (!id) {
            alert("projects ID missing!");
            return;
        }
        const confirmDelete = window.confirm("Are you sure you want to delete this projects Infromation?");
        if (confirmDelete) {
            deleteProjects({ BeURL, id, showAlert, handleTopClear, setProjects,candidateId: candidate._id })
        }
    };

    const handleCardEdit = (idx) => {
        const card = projects[idx];
        if (!card) return;

        const normalizePeriod = (isoDateStr) => {
            if (!isoDateStr) return ["", "", ""];
            const date = new Date(isoDateStr);
            const year = date.getFullYear().toString();
            const month = (date.getMonth() + 1).toString().padStart(2, "0");
            const day = date.getDate().toString().padStart(2, "0");

            return [
                year,
                month === "01" && day === "01" ? "" : month,
                month === "01" && day === "01" ? "" : day,
            ];
        };

        const certificates = {
            ...card,
            periodFrom: normalizePeriod(card.periodFrom),
            periodTo: normalizePeriod(card.periodTo),
            year: normalizePeriod(card.periodFrom)[0],
            month: normalizePeriod(card.periodFrom)[1],
            date: normalizePeriod(card.periodFrom)[2],
            projectName: card.projectName,
            clientName: card.clientName,
            description: card.description,
            isOngoing: card.isProcessing,
            _id: card._id
        };

        setTopInput({
            ...certificates,
        });

        setEditingCardId(certificates._id);
        setErrors({});
        setTouched({});
    };

    return (
        <div>
            <div className="py-4">
                {/* Top Input Panel */}
                <div className="border-2 rounded-2xl p-4 bg-white shadow-sm mb-4">
                    <h4 className="text-base font-semibold text-slate-800">Create projects</h4>            
                    {/* Inputs Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-3 md:gap-1 mt-2">
                        <InputRegister
                            label="Project name"
                            mandatory
                            value={topInput.projectName}
                            onChange={e => handleTopFieldChange("projectName", e.target.value)}
                            placeholder="Enter Project name"
                            type="text"
                            className={`w-full`}
                            error={errors.projectName}
                            border={1}
                        />
                        <InputRegister
                            label={"Client name"}
                            border={1}
                            value={topInput.clientName}
                            onChange={(e) => handleTopFieldChange("clientName", e.target.value)}
                            placeholder="Client name"
                            type="text"
                            className={"w-full"}
                            error={errors.clientName}
                        />
                        <InputRegister
                            label={"Role"}
                            mandatory
                            value={topInput.role}
                            onChange={(e) => handleTopFieldChange("role", e.target.value)}
                            placeholder="Role"
                            type="text"
                            className={"w-full"}
                            error={errors.role}
                            border={1}
                        />
                        {/* Start Date */}
                        <div>
                            <label className="text-sm text-slate-600 font-medium">Start Date</label>
                            <div className="flex gap-2 mt-2 items-center">
                                <div>
                                    <select
                                        value={topInput.periodFrom[0]}
                                        onChange={e => {
                                            const newDate = [...topInput.periodFrom];
                                            newDate[0] = e.target.value;
                                            handleTopFieldChange("periodFrom", newDate);
                                        }}
                                        className={`w-20 h-11 text-center border rounded-lg ${errors.periodFromYear && touched.periodFromYear ? "border-red-500" : "border-gray-300"}`}
                                    >
                                        <option value="">YYYY</option>
                                        {Array.from({ length: 50 }, (_, i) => new Date().getFullYear() - i).map(y => (
                                            <option key={y} value={y}>{y}</option>
                                        ))}
                                    </select>
                                </div>

                                {/* Month Dropdown */}
                                {
                                    topInput.periodFrom[0] &&
                                    <div>
                                        <select
                                            value={topInput.periodFrom[1] || ""}
                                            onChange={(e) => {
                                                const newDate = [...topInput.periodFrom];
                                                newDate[1] = e.target.value;
                                                handleTopFieldChange("periodFrom", newDate);
                                            }}
                                            className="w-16 h-11 text-center border rounded-lg"
                                        >
                                            <option value="">MM</option>
                                            {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
                                                <option key={month} value={month.toString().padStart(2, "0")}>
                                                    {month.toString().padStart(2, "0")}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                }
                                {/* Day Dropdown */}
                                {topInput.periodFrom[1] &&
                                    <div>
                                        <select
                                            value={topInput.periodFrom[2]}
                                            onChange={(e) => {
                                                const newDate = [...topInput.periodFrom];
                                                newDate[2] = e.target.value;
                                                handleTopFieldChange("periodFrom", newDate);
                                            }}
                                            className="w-16 h-11 text-center border rounded-lg"
                                        >
                                            <option value="">DD</option>
                                            {Array.from({ length: 31 }, (_, i) => i + 1).map((day) => (
                                                <option key={day} value={day.toString().padStart(2, "0")}>
                                                    {day.toString().padStart(2, "0")}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                }
                            </div>
                            {errors.periodFromYear && touched.periodFromYear && (
                                <p className="text-red-500 text-xs mt-2">{errors.periodFromYear}</p>
                            )}
                        </div>

                        {/* End Date */}

                        <div>
                            <div className="flex justify-between">
                                <label className="text-sm text-slate-600 font-medium">End Date</label>
                                <div className="flex items-center gap-2 px-6">
                                    <input
                                        type="checkbox"
                                        checked={topInput.isProcessing}
                                        onChange={e => handleTopFieldChange("isProcessing", e.target.checked)}
                                        className=" h-4 w-4 text-blue-600 border-gray-300 rounded-lg"
                                    />
                                    <span className={`text-gray-400 text-sm ${topInput.isProcessing ? "text-primary-500 font-medium" : "text-slate-600"}`}>Ongoing</span>
                                </div>
                            </div>
                            <div className="flex gap-2 items-center my-2">
                                <div>
                                    <select
                                        value={topInput.periodTo[0]}
                                        disabled={topInput.isProcessing}
                                        onChange={e => {
                                            const newDate = [...topInput.periodTo];
                                            newDate[0] = e.target.value;
                                            handleTopFieldChange("periodTo", newDate);
                                        }}
                                        className={`w-20 h-11 text-center border rounded-lg ${!topInput.isProcessing
                                            ? errors.periodToYear && touched.periodToYear
                                                ? "border-red-500"
                                                : "border-gray-300"
                                            : ""
                                            }`}
                                    >
                                        <option value="">YYYY</option>
                                        {Array.from({ length: 50 }, (_, i) => new Date().getFullYear() - i).map(y => (
                                            <option key={y} value={y}>{y}</option>
                                        ))}
                                    </select>
                                </div>

                                {/* Month Dropdown */}
                                {topInput.periodTo[0] &&
                                    <div>
                                        <select
                                            value={topInput.periodTo[1] || ""}
                                            onChange={(e) => {
                                                const newDate = [...topInput.periodTo];
                                                newDate[1] = e.target.value;
                                                handleTopFieldChange("periodTo", newDate);
                                            }}
                                            className="w-16 h-11 text-center border rounded-lg"
                                        >
                                            <option value="">MM</option>
                                            {Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
                                                <option key={month} value={month.toString().padStart(2, "0")}>
                                                    {month.toString().padStart(2, "0")}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                }
                                {/* Day Dropdown */}
                                {topInput.periodTo[1] &&
                                    <div>
                                        <select
                                            value={topInput.periodTo[2]}
                                            onChange={(e) => {
                                                const newDate = [...topInput.periodTo];
                                                newDate[2] = e.target.value;
                                                handleTopFieldChange("periodTo", newDate);
                                            }}
                                            className="w-16 h-11 text-center border rounded-lg"
                                        >
                                            <option value="">DD</option>
                                            {Array.from({ length: 31 }, (_, i) => i + 1).map((day) => (
                                                <option key={day} value={day.toString().padStart(2, "0")}>
                                                    {day.toString().padStart(2, "0")}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                }
                            </div>
                            {!topInput.isProcessing && (
                                errors.periodToYear && touched.periodToYear && (
                                    <p className="text-red-500 text-xs mt-2">{errors.periodToYear}</p>
                                ))}
                        </div>
                        <InputRegister
                            label={"Location"}
                            value={topInput.location}
                            onChange={(e) => handleTopFieldChange("location", e.target.value)}
                            placeholder="Location"
                            type="url"
                            className={"w-full"}
                            error={errors.location}
                            border={1}
                        />
                        {/* Description */}
                        <div className="flex flex-col gap-1 md:col-span-3">
                            <label className="text-sm text-slate-600 font-medium">Description</label>
                            <textarea
                                value={topInput.description}
                                onChange={e => handleTopFieldChange("description", e.target.value)}
                                placeholder="Enter description..."
                                className="w-full p-2 border border-gray-300 rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder:text-sm"
                                rows={4}
                            />
                        </div>                        
                    </div>
                    {errors.description && (
                        <p className="text-red-500 bg-red-100 px-3 rounded mt-1">{errors.description}</p>
                    )}

                    <div className="flex items-center gap-2 justify-end mt-2">
                        {editingCardId ? (
                            <div className="flex gap-3">
                                <button onClick={handleTopClear} className="px-3 py-1 rounded underline  font-semibold text-primary-500 flex items-center justify-center text-base">
                                    Clear
                                </button>
                                <div title="update" onClick={() => handleTopUpdate(editingCardId)} className=" px-1 w-[70px] md:w-[80px] rounded-lg bg-primary-400 font-semibold text-white flex items-center justify-center shadow-md cursor-pointer">
                                    Update
                                </div>
                            </div>
                        ) : (
                            <div className="flex gap-2">
                                    <button onClick={handleTopClear} className="px-3 py-1 rounded underline  font-semibold text-primary-500 flex items-center justify-center text-base">
                                    Clear
                                </button>
                                    <div onClick={handleTopAdd} className=" px-1 w-[70px] md:w-[80px] rounded-lg bg-primary-400 font-semibold text-white flex items-center justify-center shadow-md cursor-pointer">
                                   Add
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                {/* projects List */}
                <div className="mt-3 space-y-4 bg-white rounded-2xl px-5 py-3 w-full">
                    <p>
                        Projects <span>({projects.length})</span>
                    </p>
                    {projects.length === 0 && (
                        <div className="text-sm text-gray-400">
                            No projects added yet. Enter the candidate’s project above.
                        </div>
                    )}

                    {/* scroll wrapper with buttons */}
                    <div className="relative">
                        {/* Scrollable cards */}
                        <div
                            id="expScroll"
                            className="flex gap-4 overflow-x-auto px-6"
                        >
                            {projects.map((card, idx) => (
                                <div
                                    key={idx}
                                    className="bg-white border rounded-lg flex-shrink-0 shadow-md p-4 w-full sm:w-[48%] md:w-[30%]"
                                >
                                    {/* Header: Job Title + Actions */}
                                    <div className="flex justify-between items-start mb-2">
                                        <div>
                                            <p className="text-xs text-slate-400">projects name</p>
                                            <p className="font-medium text-slate-800 capitalize">
                                                {card.projectName || "-"}
                                            </p>
                                        </div>
                                        <div className="flex gap-2">
                                            <button
                                                onClick={() => handleCardEdit(idx)}
                                                className="text-slate-600 p-1 hover:text-blue-600"
                                                title="Edit"
                                            >
                                                <FiEdit2 />
                                            </button>
                                            <button
                                                onClick={() => handleCardDelete(card._id)}
                                                className="text-red-500 p-1 hover:text-red-700"
                                                title="Delete"
                                            >
                                                <MdDeleteOutline />
                                            </button>
                                        </div>
                                    </div>

                                    {/* Company Name */}
                                    <div className="mt-2">
                                        <p className="text-xs text-slate-400">Role</p>
                                        <p className="text-slate-700 capitalize">{card.role || "-"}</p>
                                    </div>

                                    {/* Date */}
                                    <div className="flex justify-between">
                                        <div className="mt-2">
                                            <p className="text-xs text-slate-400">Period from</p>
                                            <p className="text-slate-700">
                                                {(() => {
                                                    const p = formatPeriod(card.periodFrom);
                                                    return `${p.date ? p.date + " " : ""}${p.month ? p.month + " " : ""}${p.year || "-"}`;
                                                })()}
                                            </p>
                                        </div>
                                        <div className="mt-2">
                                            <p className="text-xs text-slate-400">Period to</p>
                                            <p className="text-slate-700">
                                                {(() => {
                                                    const p = formatPeriod(card.periodTo);
                                                    return `${p.date ? p.date + " " : ""}${p.month ? p.month + " " : ""}${p.year || "-"}`;
                                                })()}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>


                        <div className="flex justify-end mt-1 items-center gap-2">
                            {/* hint text */}
                            <p className="text-[10px] text-slate-400 italic">
                                Use ← and → buttons to scroll
                            </p>
                            {/* Left button */}
                            <button
                                onClick={() => {
                                    document.getElementById("expScroll").scrollBy({ left: -200, behavior: "smooth" });
                                }}
                                className=" bg-white shadow rounded-full p-1 text-xs"
                            >
                                ◀
                            </button>
                            {/* Right button */}
                            <button
                                onClick={() => {
                                    document.getElementById("expScroll").scrollBy({ left: 200, behavior: "smooth" });
                                }}
                                className="  bg-white shadow rounded-full p-1 text-xs"
                            >
                                ▶
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};












